import {STATES} from './stack';
import sortBy from 'lodash/sortBy';
import {selectPageById} from 'state/navigation/navigationSelectors';
import {PLAYBOOK_STATES} from './stackConstants';
import get from 'lodash/get';

export const isStackLoading = (state, id) =>
  state.stack.stack.stacksStateById[id] === STATES.LOADING;

export const hasLoadedStack = (state, id) =>
  state.stack.stack.stacksStateById[id] === STATES.LOADED;

export const selectStackById = (state, id) => state.stack.stack.stacks[id];

export const selectParentStackById = (state, id) =>
  state.stack.stack.stacks[id];

export const selectCollectionById = (state, collectionId) =>
  state.stack.stack.collections[collectionId];

export const selectCollectionsByStackId = (state, stackId) =>
  sortBy(
    Array.from(state.stack.stack.collectionsByStackId[stackId] || []).map(
      collectionId => state.stack.stack.collections[collectionId]
    ),
    'sortIndex'
  );

export const selectCanRequestAccess = (state, stackId) => {
  const isAccessDenied = !!state.stack.stack.accessDeniedStacks[stackId];
  const isInNavigation = !!selectPageById(state, stackId);

  return isAccessDenied && isInNavigation;
};

export const selectHasRequestedAccess = (state, stackId) =>
  state.stack.stack.accessRequests.has(stackId);

export const selectIsSampleData = (state, stackId) => {
  const stack = selectStackById(state, stackId);
  const playbookState = get(stack, ['playbook', 'state']);
  return (
    playbookState === PLAYBOOK_STATES.DEPLOY_UNKNOWN ||
    playbookState === PLAYBOOK_STATES.DEPLOYED ||
    playbookState === PLAYBOOK_STATES.DEPLOYING
  );
};

export const selectPowerUpAssignment = (state, stackId) =>
  state.stack.stack.powerUpAssignments[stackId];
